export default {
      id: "logoFooter-usage",
      viewBox: "0 0 70 24",
      url: "assets/" + "sprite.svg#logoFooter-usage",
      toString: function () {
        return this.url;
      }
    }